import UrlHelper from 'Libs/helpers/url';

export const HSN_LENGTH = 4;
export const TSN_LENGTH = 3;

export function getHsnTsnFromUrl() {
  if (typeof window === 'undefined') {
    return null;
  }

  const urlParams = new URLSearchParams(window.location.search);

  const combinedHsnTsnValue = (urlParams.get('hsn-tsn') || '').trim();
  const [combinedHsn = '', combinedTsn = ''] = combinedHsnTsnValue.split(
    '-',
    2
  );

  const hsn = (combinedHsn || urlParams.get('hsn') || '')
    .trim()
    .slice(0, HSN_LENGTH);
  const tsn = (combinedTsn || urlParams.get('tsn') || '')
    .trim()
    .slice(0, TSN_LENGTH);

  if (!hsn && !tsn) {
    return null;
  }

  return { hsn, tsn };
}

export function clearHsnTsnFromUrl() {
  if (typeof window === 'undefined') {
    return;
  }

  const params = UrlHelper.getUrlParameters();
  delete params['hsn-tsn'];
  delete params.hsn;
  delete params.tsn;

  const url = UrlHelper.assembleUrl({
    url: window.location.href,
    parameters: params,
    shouldMerge: false,
  });

  window.history.replaceState(null, '', url);
}
